const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '');

const resolveUrl = (input) => {
  if (!input) {
    return API_BASE;
  }
  if (/^https?:\/\//i.test(input)) {
    return input;
  }
  if (input.startsWith('/api')) {
    const suffix = input.slice(4); // drop leading '/api'
    return `${API_BASE}${suffix}`;
  }
  if (input.startsWith('/')) {
    return `${API_BASE}${input}`;
  }
  return `${API_BASE}/${input}`;
};

// Utility function to handle fetch with authentication
export const fetchWithAuth = async (url, options = {}) => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  
  const isFormData = options && options.body instanceof FormData;
  const headers = {
    ...(options.headers || {})
  };

  // Add authorization header if token exists
  if (token) {
    headers.Authorization = headers.Authorization || `Bearer ${token}`;
  }

  // Add required Dailey Core authentication headers
  headers['X-Application'] = headers['X-Application'] || 'Dailey Forms';
  headers['X-App-Name'] = headers['X-App-Name'] || 'Dailey Forms';
  headers['X-Client-Id'] = headers['X-Client-Id'] || 'dailey-forms';

  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const fetchOptions = {
    ...options,
    headers
  };

  const response = await fetch(resolveUrl(url), fetchOptions);

  if (response.status === 401) {
    if (!window.location.pathname.includes('/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('username');
      localStorage.removeItem('selectedBuilding');
      window.location.href = '/login?session=expired';
      throw new Error('Session expired. Please login again.');
    }
  } else if (response.status === 403) {
    throw new Error('You do not have access to this resource.');
  }

  return response;
};
